/**
 * ChatGPT Ads — fire order_created when a purchase completes.
 * Primary path: GoKwik dataLayer (order-placed / gk_purchase).
 * Secondary: Shopify thank-you / order-status URL patterns.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'oaiq_order_created_ids';
  var firedIds = {};

  try {
    firedIds = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}') || {};
  } catch (e) {
    firedIds = {};
  }

  function remember(id) {
    if (!id) return;
    firedIds[id] = Date.now();
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(firedIds));
    } catch (e) {}
  }

  function alreadyFired(id) {
    return id ? Boolean(firedIds[id]) : false;
  }

  function extractOrderId(entry) {
    if (!entry || typeof entry !== 'object') return '';
    var ecommerce = entry.ecommerce || {};
    return String(
      entry.transaction_id ||
        entry.order_id ||
        entry.orderId ||
        entry.transactionId ||
        ecommerce.transaction_id ||
        ecommerce.order_id ||
        (entry.order && (entry.order.id || entry.order.name || entry.order.order_number)) ||
        ''
    );
  }

  function isPurchaseEntry(entry) {
    if (!entry || typeof entry !== 'object') return false;
    var eventName = String(entry.event || entry.eventName || entry.name || '').toLowerCase();
    if (
      eventName === 'order-placed' ||
      eventName === 'gk_purchase' ||
      eventName === 'purchase' ||
      eventName === 'order_created' ||
      eventName === 'checkout_completed'
    ) {
      return true;
    }
    if (entry.ecommerce && entry.ecommerce.purchase) return true;
    return false;
  }

  function measureOrderCreated(orderId) {
    var id = orderId || 'anon_' + Date.now();
    if (alreadyFired(id)) return false;
    if (typeof window.oaiq !== 'function') return false;

    window.oaiq('measure', 'order_created', { type: 'contents' });
    remember(id);
    return true;
  }

  function handleDataLayerEntry(entry) {
    if (!isPurchaseEntry(entry)) return;
    measureOrderCreated(extractOrderId(entry));
  }

  function installDataLayerHook() {
    window.dataLayer = window.dataLayer || [];

    var currentPush = window.dataLayer.push;
    if (currentPush && currentPush.__oaiqWrapped) return;

    var i;
    for (i = 0; i < window.dataLayer.length; i++) {
      handleDataLayerEntry(window.dataLayer[i]);
    }

    var originalPush = currentPush;
    var wrappedPush = function () {
      for (i = 0; i < arguments.length; i++) {
        handleDataLayerEntry(arguments[i]);
      }
      return originalPush.apply(window.dataLayer, arguments);
    };
    wrappedPush.__oaiqWrapped = true;
    window.dataLayer.push = wrappedPush;
  }

  function maybeThankYouPage() {
    var path = (window.location && window.location.pathname) || '';
    var search = (window.location && window.location.search) || '';
    var isThankYou =
      /\/thank[_-]?you/i.test(path) ||
      /\/checkouts\/.+\/thank_you/i.test(path) ||
      /\/orders\//i.test(path) ||
      /[?&]purchase=1/i.test(search);

    if (!isThankYou) return;

    var orderMatch = path.match(/\/orders\/([^/?#]+)/i);
    var orderId = orderMatch ? orderMatch[1] : path + search;
    measureOrderCreated('url_' + orderId);
  }

  function init() {
    installDataLayerHook();
    maybeThankYouPage();

    // GoKwik may emit after pixel init; retry briefly if oaiq loads late.
    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (typeof window.oaiq === 'function' || attempts > 40) {
        window.clearInterval(timer);
        maybeThankYouPage();
      }
    }, 250);
  }

  // Expose for manual / thank-you additional scripts if needed.
  window.blubeinChatgptOrderCreated = measureOrderCreated;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
